module.exports = __webpack_public_path__ + "static/4-b88d00e7f24d3788e1c5151f2967f3da.jpg";